import { Injectable } from '@angular/core';
import { Breadcrumb } from '@app/models/_base/breadcrumb.model';
import { Subject } from 'rxjs';

@Injectable()
export class RouteBreadcrumbs {
  breadcrumbs: Subject<Breadcrumb[]> = new Subject<Breadcrumb[]>();
  disableBackButton: Subject<boolean> = new Subject<boolean>();
}



// WEBPACK FOOTER //
// ./src/app/services/routeBreadcrumbs.service.ts